import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SoftButton from "components/SoftButton";

function ConfirmDeleteModal({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: 3,
          textAlign: "center",
          maxWidth: "400px",
          mx: "auto",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fcebea",
              borderRadius: "50%",
              width: 72,
              height: 72,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DeleteOutlineIcon color="error" fontSize="large" />
          </Box>
        </Box>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Er du sikker?
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Vil du virkelig slette denne malen? Denne handlingen kan ikke angres.
        </Typography>

        <Box display="flex" justifyContent="center" gap={2}>
          <SoftButton onClick={onClose} variant="contained" color="error">
            Avbryt
          </SoftButton>
          <SoftButton onClick={onConfirm} variant="gradient" color="info">
            Slett
          </SoftButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ConfirmDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmDeleteModal;
